import { useAppSelector } from '../hooks/redux';
import ProtectedRoute from '../components/Auth/ProtectedRoute';

const WalletPage = () => {
  const { user } = useAppSelector((state) => state.auth);
  const balance = user?.wallet?.balance ?? 1250.75;

  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <h1 className="text-3xl font-bold mb-6 text-[var(--color-default-font)]">My Wallet</h1>
      
      <div className="bg-[var(--color-default-background)] border border-[var(--color-neutral-border)] rounded-lg p-6 shadow-lg">
        <div className="flex items-center justify-between mb-4">
          <div>
            <p className="text-sm text-[var(--color-subtext-color)] mb-1">Available Balance</p>
            <p className="text-4xl font-bold text-[var(--color-default-font)]">
              XCD {balance.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </p>
          </div>
          <div className="w-16 h-16 bg-gradient-to-br from-[var(--color-success-600)] to-[var(--color-brand-primary)] rounded-full flex items-center justify-center">
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
            </svg>
          </div>
        </div>
        
        <div className="mt-6 pt-6 border-t border-[var(--color-neutral-border)]">
          <p className="text-sm text-[var(--color-subtext-color)] mb-4">
            Your wallet balance represents earnings from participating in community projects. 
            When approved projects generate value, your share is automatically credited to your wallet.
          </p>
          <div className="bg-[var(--color-neutral-50)] rounded-lg p-4">
            <p className="text-sm font-semibold text-[var(--color-default-font)] mb-2">How to earn:</p>
            <ul className="text-sm text-[var(--color-subtext-color)] space-y-1">
              <li>• Propose projects that get approved</li>
              <li>• Vote on community initiatives</li>
              <li>• Participate in project discussions</li>
              <li>• Track project progress and milestones</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

const WalletPageWithAuth = () => (
  <ProtectedRoute>
    <WalletPage />
  </ProtectedRoute>
);

export default WalletPageWithAuth;
